import moment from "moment";
import { RecurringSchedule } from '../domain/recurringSchedule'
import { pluralize } from '../helpers/strings'
import dayjs from 'dayjs'

export function calcStartWeek(date: string) {
  const monthStartDayOfWeek = moment(date).startOf('month').day()
  const startWeekCalc = moment(date).week() - moment(date).startOf('month').week()
  return (monthStartDayOfWeek > moment(date).day()) ? startWeekCalc : startWeekCalc + 1
}

export function getDateFromWeekdayAndWeekOfMonth(weekday: number, weekOfMonth: number, inputDate: string) {
  let date = moment(inputDate).startOf('month')
  const startDay = date.day()

  date = date.add(weekOfMonth - 1, 'weeks')
  date.subtract(date.day(), 'days')
  date = date.add(weekday, 'days')
  if (startDay > weekday) {
    date.add(7, 'days')
  }

  return date
}
export type PreparedDate = {
  startDate: string,
  endDate: string,
  startTime: string,
  endTime: string,
}

export function prepareNextDate(setRecurringSchedule: any, rs: any, previous: any, endDate: any = null) {
  const newPreparedDate: PreparedDate = {
    startDate: '',
    endDate: '',
    startTime: rs.startTime,
    endTime: rs.endTime
  }

  switch (setRecurringSchedule.repeatsEvery.type) {
      case 'day':
      case 'year':
          newPreparedDate.startDate = rs.startDate.format('MM/DD/YYYY');
          newPreparedDate.endDate = rs.startDate.format('MM/DD/YYYY');

          rs.startDate = rs.startDate.add(setRecurringSchedule.repeatsEvery.qty, setRecurringSchedule.repeatsEvery.type + 's');
          rs.preparedDates.push(newPreparedDate);
          break;
      case 'week': {
          // find selected day of the week
          const dayOfTheWeek = parseInt(rs.startDate.day());
          const weeklyRepeatsOn = parseInt(setRecurringSchedule.weeklyRepeatsOn);

          // if the select startDate day is different than the weeklyRepeatsOn day, find the next weeklyRepeatsOn day
          if (dayOfTheWeek != weeklyRepeatsOn) {
              const daysToBeAdded = weeklyRepeatsOn > dayOfTheWeek ? weeklyRepeatsOn - dayOfTheWeek : 7 - (dayOfTheWeek - weeklyRepeatsOn)
              rs.startDate = moment(rs.startDate).add(daysToBeAdded, 'days')
          }

          newPreparedDate.startDate = rs.startDate.format('MM/DD/YYYY');
          newPreparedDate.endDate = rs.startDate.format('MM/DD/YYYY');

          // recurring schedule by n week(s)
          rs.startDate = rs.startDate.add(setRecurringSchedule.repeatsEvery.qty, 'weeks');
          rs.preparedDates.push(newPreparedDate);
          break;
      }
      case 'month': {
          const currentMonth = moment(rs.startDate).month()
          const previousMonth = previous ? moment(previous.startDate).month() : null

          if(currentMonth === previousMonth){
              rs.startDate = rs.startDate.add(setRecurringSchedule.repeatsEvery.qty, 'months');
          } 

          if (setRecurringSchedule.monthlyRepeatsOn == 'nthDayOfTheMonth' && setRecurringSchedule.monthlyRepeatsOnOptions) {
              const options = setRecurringSchedule.monthlyRepeatsOnOptions.filter((option: { id: string; }) => option.id == 'nthDayOfTheMonth')[0];
              rs.startDate = getDateFromWeekdayAndWeekOfMonth(options.dayOfWeek, options.weekOfMonth, rs.startDate);
          }

          newPreparedDate.startDate = rs.startDate.format('MM/DD/YYYY');
          newPreparedDate.endDate = rs.startDate.format('MM/DD/YYYY');

          if( endDate === null){
              rs.preparedDates.push(newPreparedDate)
          }
          else if(rs.startDate.isSameOrBefore(endDate)){
              rs.preparedDates.push(newPreparedDate)
          }
          break;
      }
  }
}

export function getWeekNumberName(weekNumber: number) {
  const weeksArray = ["first", "second", "third", "fourth", "fifth"];
  return weeksArray[weekNumber - 1];
}

export function getMonthlyDescription(monthlyRepeatsOn: any, startsOn: any) {
  switch (monthlyRepeatsOn) {
      case 'currentDay':
          return `day ${moment(startsOn).format("D")}, `;
      case 'nthDayOfTheMonth': {
          const currentDate = moment(startsOn)
          return `the ${getWeekNumberName(calcStartWeek(startsOn))} ${currentDate.format("dddd")}, `;
      }
  }
}


export function getDayNumberName(dayNumber: number) {
  const daysArray = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  return daysArray[dayNumber];
}

export function appendRepeatsEveryQty(qty: number) {
  switch (qty) {
      case 1:
          return '';
      case 2:
          return '2nd ';
      case 3:
          return '3rd ';
      default:
          return `${qty}th `;
  }
}

export const DefaultSchedule = {
  selectedScheduleItemName: '', // display purpose: stores the master task name
  selectedTaskOccurences: 0, // display purpose: stores the number of recurring tasks
  selectedTasks: [], // stores the selected tasks to use for recurring schedule calculation
  startsOn: moment().format("MMMM DD, YYYY"),
  repeatsEvery: {
      qty: 1,
      type: "week" // default repeatsEvery is 'day'
  },
  repeatsAt: {
      startTime: "08:00:00",
      endTime: "09:00:00"
  },
  weeklyRepeatsOn: "1", // default weekly is 'monday'
  monthlyRepeatsOn: "currentDay", // default monthly is 'currentDay'
  endsOn: moment().format("MMMM DD, YYYY"), // stores the calculated day on which the recurring schedule ends
  monthlyRepeatsOnOptions: [], // stores the dynamically calculated options for monthly recurring schedule
  preparedDates: [] // stores the prepared dates for the selected maintenant contract tasks
}

export function getInitialRecurringSchedule() {
  return DefaultSchedule
}

export function prepareDatesByVisits(setRecurringSchedule: any, selectedTasksCount: any) {
  const visitsCount = selectedTasksCount || setRecurringSchedule.selectedScheduleItems.length,
      rs = {
        preparedDates: [],
        startDate: moment(setRecurringSchedule.startsOn),
        startTime: setRecurringSchedule.repeatsAt.startTime,
        endTime: setRecurringSchedule.repeatsAt.endTime,
        monthCorrectionWeekAdded: false // used by the recurring monthly nthDayOfTheMonth option
      };

  for (let i = 0; i < visitsCount; i++) {
    prepareNextDate(setRecurringSchedule, rs, rs.preparedDates[i-1] ?? null);
  }

  return rs.preparedDates;
}

export function prepareDatesByEndDate(setRecurringSchedule: any) {
  const endDate = moment(setRecurringSchedule.endsOn),
      rs = {
          preparedDates: [],
          startDate: moment(setRecurringSchedule.startsOn),
          startTime: setRecurringSchedule.repeatsAt.startTime,
          endTime: setRecurringSchedule.repeatsAt.endTime,
          monthCorrectionWeekAdded: false // used by the recurring monthly nthDayOfTheMonth option
      };

  let i = 0;
  while (rs.startDate.isSameOrBefore(endDate)){
      const previousDate = rs.preparedDates[i-1] ?? null
      prepareNextDate(setRecurringSchedule, rs,  previousDate, endDate)
      i++
  }

  return rs.preparedDates;
}

export function refreshMonthlyRepeatsOnOptions(startsOn: any) {
  const monthlyRepeatsOnOptions = [],
      currentDate = moment(startsOn);

  monthlyRepeatsOnOptions.push({ id: 'currentDay', name: "Monthly on day " + currentDate.date() })
  monthlyRepeatsOnOptions.push({ id: 'nthDayOfTheMonth', name: "Monthly on the " + getWeekNumberName(calcStartWeek(startsOn)) + " " + currentDate.format("dddd"), dayOfWeek: currentDate.day(), weekOfMonth: calcStartWeek(startsOn) })

  return monthlyRepeatsOnOptions;
}

export function prepareRecurringScheduleConfigDescription(recurringScheduleConfigJson: any): string {
  const rs = JSON.parse(recurringScheduleConfigJson)
  let configDescription = `Starts on ${rs.startsOn}, `;

  configDescription += 'repeats every ';
  configDescription += appendRepeatsEveryQty(rs.repeatsEvery.qty);
  switch (rs.repeatsEvery.type) {
      case 'day':
          configDescription += 'day, ';
          break;
      case 'week':
          configDescription += 'week, on ';
          configDescription += `${getDayNumberName(rs.weeklyRepeatsOn)}s, `;
          break;
      case 'month':
          configDescription += 'month, on ';
          configDescription += `${getMonthlyDescription(rs.monthlyRepeatsOn, rs.startsOn)}`;
          break;
      case 'year':
          configDescription += 'year, ';
          break;
  }

  configDescription += `and ends on ${rs.endsOn} `;
  return configDescription;
}

export const recurringDescription = (schedule: RecurringSchedule | undefined) => {
  if (!schedule) {
    return ''
  }
  
  if (!schedule || !schedule.isRecurring) {
    return ''
  }

  let description = `Repeats every ${schedule.repeatCount} ${pluralize(schedule.repeatCount, schedule.repeatUnits)}`

  if (schedule.endType === 'date') {
    description += ` until ${dayjs(schedule.endDate).format('MM d, YYYY')}`
  }
  if (schedule.endType === 'occurrences') {
    description += ` and ends after ${schedule.occurrences} ${pluralize(schedule.occurrences, 'occurrences')}`
  }

  return description
}

export const convertNewScheduleToOld = (recurringSchedule: RecurringSchedule, startsOn: dayjs.Dayjs): RecurringScheduleConfig => {
  const result = {
    startsOn: startsOn.format('MMMM DD, YYYY'),
    repeatsEvery: {
      qty: recurringSchedule.repeatCount,
      type: recurringSchedule.repeatUnits
    },
    repeatsAt: {
      startTime: undefined,
      endTime: undefined
    },
    weeklyRepeatsOn: startsOn.day().toString(),
    monthlyRepeatsOn: 'currentDay',
    endsOn: getEndDate(recurringSchedule, startsOn).format('MMMM DD, YYYY')
  }

  return result
}

const getEndDate = (recuringSchedule: RecurringSchedule, startDate: dayjs.Dayjs): dayjs.Dayjs => {
  const { endType, endDate, repeatCount, repeatUnits, occurrences } = recuringSchedule
  if (endType === 'date') {
    return dayjs(endDate)
  }

  return startDate.add(repeatCount * occurrences, repeatUnits)
}

export type RecurringScheduleConfig = {
  startsOn: any,
  repeatsEvery: {
    qty: number
    type: string
  }
  repeatsAt: {
    startTime: string | undefined
    endTime: string | undefined
  } | undefined
  weeklyRepeatsOn: string
  monthlyRepeatsOn: string
  endsOn: string | undefined
}

export function mapRecurringScheduleToConfigJson(s: any) {
  const recurringScheduleConfig: RecurringScheduleConfig = {
      startsOn: s.startsOn,
      repeatsEvery: s.repeatsEvery,
      repeatsAt: s.repeatsAt,
      weeklyRepeatsOn: s.weeklyRepeatsOn,
      monthlyRepeatsOn: s.monthlyRepeatsOn,
      endsOn: s.endsOn
  }
  return JSON.stringify(recurringScheduleConfig);
}

export const updateRecurringScheduleFromUI = (uiState: any, originalSchedule: RecurringSchedule): RecurringSchedule => {
  return {
    ...originalSchedule,
    repeatUnits: uiState.repeatsEvery.type,
    repeatCount: uiState.repeatsEvery.qty,
  }
}